<template lang="pug">
  dv-form(
    ref="form"
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-sheet.d-flex.gap-16(
      color="transparent"
      width="100%"
    )
      .d-flex(
        v-if="$slots.prepend"
        style="margin-top: 46px;"
      )
        slot(name="prepend")
      v-row.flex-grow-1
        v-col.flex-grow-1(cols="auto")
          dv-form-nested(
            :field="fields.media"
          )
        v-col(
          v-if="withScore"
          cols="4"
        )
          dv-form-field(
            :field="fields.score"
          )
      .d-flex(style="margin-top: 46px;")
        dv-btn.ui-neutral.lighten-4.mt-n3(
          icon
          large
          :disabled="!canDelete"
          @click="$emit('delete')"
        )
          v-icon(color="ui-error") $ui-delete
</template>

<script>
import DvTextOrImageField from '@/packages/ui/components/inputs/DvTextOrImageField.vue';
import DvNumberField from '@/packages/ui/components/inputs/DvNumberField.vue';
import DvFormNested from '@/packages/ui/components/forms/DvFormNested.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvFormNested,
    DvFormField,
    DvForm,
    DvBtn,
  },
  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },
    withScore: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    schema() {
      const { formData } = this;
      const { is_correct } = formData;

      return [
        {
          name: 'media',
          label: 'Ответ',
          rules: 'required_fill',
          component: DvTextOrImageField,
          props: {
            imageKey: 'images',
            returnMultiple: true,
          },
        },
        {
          name: 'score',
          value: is_correct ? 'score' : 'penalty_score',
          label: is_correct ? 'Баллов за ответ' : 'Штраф в баллах',
          rules: 'required_fill',
          component: DvNumberField,
          props: {
            min: 0,
            max: 999,
            placeholder: undefined,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
        this.$refs.form.reset(val);
      },
      deep: true,
    },
    formData(val) {
      this.$emit('input', val);
    },
    'formData.is_correct': {
      handler(val) {
        const { score, penalty_score } = this.formData;

        if (this.withScore) {
          this.formData.score = val ? penalty_score : undefined;
          this.formData.penalty_score = !val ? score : undefined;
        }
      },
    },
  },
};
</script>
